export const getPageIndex = (pages, pageId) => {
  const pageIndex = pages.findIndex(page => page.id === pageId);

  return pageIndex > -1 ? pageIndex : 0;
};
